import React, { useState, useCallback } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { useLanguage } from '../../context/LanguageContext';

const LQIP = 'data:image/webp;base64,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';

const AVIF_SRCSET = [
  'https://images.unsplash.com/photo-1761139844529-4cc441e01457?crop=entropy&cs=srgb&fm=avif&w=640&q=30 640w',
  'https://images.unsplash.com/photo-1761139844529-4cc441e01457?crop=entropy&cs=srgb&fm=avif&w=1024&q=35 1024w',
  'https://images.unsplash.com/photo-1761139844529-4cc441e01457?crop=entropy&cs=srgb&fm=avif&w=1400&q=35 1400w',
].join(', ');

const WEBP_SRCSET = [
  'https://images.unsplash.com/photo-1761139844529-4cc441e01457?crop=entropy&cs=srgb&fm=webp&w=640&q=40 640w',
  'https://images.unsplash.com/photo-1761139844529-4cc441e01457?crop=entropy&cs=srgb&fm=webp&w=1024&q=40 1024w',
  'https://images.unsplash.com/photo-1761139844529-4cc441e01457?crop=entropy&cs=srgb&fm=webp&w=1400&q=40 1400w',
].join(', ');

const FALLBACK_SRC = 'https://images.unsplash.com/photo-1761139844529-4cc441e01457?crop=entropy&cs=srgb&fm=webp&w=1400&q=40';

const Hero = () => {
  const { t, language } = useLanguage();
  const [imgLoaded, setImgLoaded] = useState(false);
  const onLoad = useCallback(() => setImgLoaded(true), []);

  return (
    <section
      className="relative min-h-screen flex items-center overflow-hidden"
      data-testid="hero-section"
    >
      {/* Background: LQIP → full image */}
      <div className="absolute inset-0">
        {/* LQIP blurred placeholder — renders instantly */}
        <img
          src={LQIP}
          alt=""
          aria-hidden="true"
          className="absolute inset-0 w-full h-full object-cover"
          style={{
            filter: 'blur(20px) brightness(1) contrast(1.1)',
            transform: 'scale(1.1)',
            opacity: imgLoaded ? 0 : 1,
            transition: 'opacity 0.4s ease',
          }}
        />
        {/* Full image — loads progressively */}
        <picture>
          <source type="image/avif" srcSet={AVIF_SRCSET} sizes="100vw" />
          <source type="image/webp" srcSet={WEBP_SRCSET} sizes="100vw" />
          <img
            src={FALLBACK_SRC}
            alt="Véhicule neuf premium - Consultauto accompagnement automobile Montréal"
            className="absolute inset-0 w-full h-full object-cover"
            style={{
              filter: 'brightness(1) contrast(1.1)',
              opacity: imgLoaded ? 1 : 0,
              transition: 'opacity 0.4s ease',
            }}
            fetchPriority="high"
            decoding="async"
            loading="eager"
            width={1400}
            height={933}
            onLoad={onLoad}
          />
        </picture>
        {/* Overlay — renders instantly */}
        <div
          className="absolute inset-0 hidden md:block"
          style={{
            background: 'linear-gradient(to right, rgba(0,0,0,0.85) 0%, rgba(0,0,0,0.5) 50%, rgba(0,0,0,0) 100%)',
            zIndex: 1,
          }}
        />
        <div
          className="absolute inset-0 md:hidden"
          style={{ background: 'rgba(0,0,0,0.75)', zIndex: 1 }}
        />
      </div>

      {/* Text content — renders BEFORE image, no JS animation blocking */}
      <div className="relative z-[2] container-custom py-32">
        <div style={{ maxWidth: 650, textAlign: 'left' }}>
          <h1
            className="hero-fade font-sans text-white"
            style={{
              fontSize: 'clamp(2rem, 5vw, 3.5rem)',
              lineHeight: 1.2,
              fontWeight: 700,
              textShadow: '0 4px 15px rgba(0,0,0,0.8)',
              letterSpacing: '-0.02em',
              marginBottom: 20,
              animationDelay: '0.05s',
            }}
            data-testid="hero-title"
          >
            {language === 'fr'
              ? "Acheter un véhicule neuf est complexe."
              : 'Buying a new vehicle is complex.'}
          </h1>

          <p
            className="hero-fade font-sans"
            style={{
              color: '#ffffff',
              fontSize: 'clamp(1.1rem, 2vw, 1.4rem)',
              fontWeight: 400,
              lineHeight: 1.6,
              textShadow: '0 2px 10px rgba(0,0,0,0.9)',
              maxWidth: 600,
              marginBottom: 35,
              animationDelay: '0.15s',
            }}
            data-testid="hero-conclusion"
          >
            {language === 'fr'
              ? 'Nous orchestrons chaque étape — pour vous, sur mesure.'
              : 'We orchestrate every step — for you, tailored.'}
          </p>

          <div className="hero-fade" style={{ animationDelay: '0.25s' }}>
            <Link
              to="/rendez-vous"
              className="inline-flex items-center gap-3"
              style={{
                backgroundColor: '#ffffff',
                color: '#000000',
                padding: '16px 32px',
                borderRadius: 50,
                fontWeight: 600,
                fontSize: '1.1rem',
                textDecoration: 'none',
                marginTop: 40,
                boxShadow: '0 4px 15px rgba(0,0,0,0.3)',
                transition: 'all 0.3s ease',
                position: 'relative',
                zIndex: 999,
                display: 'inline-flex',
              }}
              data-testid="hero-cta"
            >
              {t.hero.cta}
              <ArrowRight className="w-4 h-4" />
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
